import { render } from "./tpl_exhibition.vue?vue&type=template&id=0415e99a&scoped=true"
import script from "./tpl_exhibition.vue?vue&type=script&lang=js"
export * from "./tpl_exhibition.vue?vue&type=script&lang=js"

import "./tpl_exhibition.vue?vue&type=style&index=0&id=0415e99a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0415e99a"],['__file',"src/views/dragger/template/tpl_exhibition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0415e99a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0415e99a', __exports__)) {
    console.log('reload')
    api.reload('0415e99a', __exports__)
  }
  
  module.hot.accept("./tpl_exhibition.vue?vue&type=template&id=0415e99a&scoped=true", () => {
    console.log('re-render')
    api.rerender('0415e99a', render)
  })

}


export default __exports__